<template>
  <v-dialog :value="true" persistent max-width="640">
    <v-card>
      <v-card-title>{{ entry.id ? 'Edit saved location' : 'Add saved location' }}</v-card-title>
      <v-card-text>
        <p>Saved locations can be reused across loads. Existing load stops stay unchanged.</p>
        <v-alert v-if="error" type="error" dense outlined>{{ error }}</v-alert>
        <v-form ref="form" @submit.prevent="save">
          <v-text-field v-model="entry.name" label="Location name" outlined dense
            :rules="[required, limit(255)]" maxlength="255" :disabled="saving" />
          <v-text-field v-model="entry.path" label="Street address, city, state and ZIP"
            outlined dense :rules="[required, limit(500)]" maxlength="500" :disabled="saving" />
          <v-select v-model="entry.kind" label="Use for" :items="kinds"
            outlined dense :disabled="saving" />
          <v-text-field v-model="entry.contact" label="Contact (optional)" outlined dense
            :rules="[limit(100)]" maxlength="100" :disabled="saving" />
          <v-textarea v-model="entry.notes" label="Location notes (optional)" outlined rows="3"
            :rules="[limit(2000)]" maxlength="2000" :disabled="saving" />
          <div class="d-flex justify-end">
            <v-btn text :disabled="saving" @click="$emit('close')">Cancel</v-btn>
            <v-btn color="primary" type="submit" :loading="saving" :disabled="blocked">
              Save location
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { saveLocation, featureError } from '@/services/loadTools';

export default {
  name: 'LocationEditor',
  props: {
    location: { type: Object, default: () => ({}) },
    kind: { type: String, default: 'both' },
  },
  data() {
    return {
      entry: {
        name: '', path: '', contact: '', notes: '', kind: this.kind, ...this.location,
      },
      saving: false,
      blocked: false,
      error: '',
      kinds: [
        { text: 'Pickup and delivery', value: 'both' },
        { text: 'Pickup (shipper)', value: 'shipper' },
        { text: 'Delivery (receiver)', value: 'consignee' },
      ],
      required: (value) => !!value?.trim() || 'Required',
    };
  },
  methods: {
    limit(max) { return (value) => (value || '').length <= max || `Maximum ${max} characters`; },
    async save() {
      if (this.saving || this.blocked || !this.$refs.form.validate()) return;
      this.saving = true;
      this.error = '';
      try {
        const saved = await saveLocation(this.entry);
        this.$emit('saved', saved);
      } catch (error) {
        const status = error.response?.status;
        this.blocked = !status || status >= 500 || status === 409;
        this.error = featureError(
          error,
          'The save could not be confirmed. Close this form and refresh the address book before trying again.',
        );
        if (status === 409) this.error += ' Close this form and reopen the location to see the latest changes.';
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
